import { EmbeddedMessage } from 'constants/messageMediums';
import { BASE } from 'constants/templateTypes';
import { useQueryCampaignsByPlacementId } from 'modules/campaigns/editor/hooks';
import { EmbeddedContentDefinition } from 'modules/graphql';
import { ACTIVE_CAMPAIGN_STATES_SET } from 'modules/placements/constants';
import { useArchivePlacement } from 'modules/placements/hooks/useArchivePlacement';
import { fetchTemplates } from 'modules/templatePicker/ducks/actions';
import {
  getFetchingTemplates,
  getTemplateDetailsById,
} from 'modules/templatePicker/ducks/selectors';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BUTTON_VARIANTS, Button } from 'ui/button';
import { Archive } from 'ui/icons';
import { MODAL_SIZES, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { Body2 } from 'ui/theme';
import { usePlacementsManageContext } from '../../context/PlacementsManageContext';

const MAX_FETCH_SIZE = 100;

export const PlacementsArchiveModal = () => {
  const dispatch = useDispatch();
  const { placementToArchive, closeArchiveModal } = usePlacementsManageContext();
  const { archivePlacement } = useArchivePlacement();
  const { campaigns } = useQueryCampaignsByPlacementId(placementToArchive?.id);
  const activeCampaigns = campaigns.filter((c) => ACTIVE_CAMPAIGN_STATES_SET.has(c.campaignState));

  const handleArchive = () => {
    archivePlacement({ variables: { id: placementToArchive?.id } });
  };

  const templatesById: Record<number, EmbeddedContentDefinition> =
    useSelector(getTemplateDetailsById) || {};
  const templatesForPlacement = Object.values(templatesById).filter(
    (t) => t.placementId === placementToArchive?.id,
  );
  const isFetchingTemplates = useSelector(getFetchingTemplates);

  useEffect(() => {
    dispatch(
      fetchTemplates({
        filter: undefined,
        messageMedium: EmbeddedMessage,
        orderBy: 'updatedAtRaw',
        page: 1,
        pageSize: MAX_FETCH_SIZE,
        placementId: placementToArchive?.id,
        queryString: undefined,
        sorting: 'desc',
        templateType: BASE,
      }),
    );
  }, [placementToArchive]);

  return (
    <Modal
      id="placement-archive-modal"
      isModalOpen
      onClose={closeArchiveModal}
      size={MODAL_SIZES.SMALL}
    >
      <ModalHeader>Archive placement</ModalHeader>
      <ModalBody>
        <Body2>
          Are you sure you want to archive placement{' '}
          <strong>{placementToArchive?.placementName}</strong>?
          <br />
          <br />
          This placement is currently being used in <strong>{activeCampaigns.length}</strong> active
          campaigns and{' '}
          <strong>
            {!isFetchingTemplates &&
              `${templatesForPlacement.length}${
                templatesForPlacement.length === MAX_FETCH_SIZE ? ' or more' : ''
              }`}
          </strong>{' '}
          templates. Active campaigns will deactivate upon archiving.
        </Body2>
      </ModalBody>
      <ModalFooter>
        <Button onClick={handleArchive} variant={BUTTON_VARIANTS.DESTRUCTIVE}>
          <Archive />
          Archive placement
        </Button>
      </ModalFooter>
    </Modal>
  );
};
